import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { asRecord } from '../../activities/types.js';
import { toPointer } from '../../core/issues.js';
import { GAMESHOW_QUIZ_ACTIVITY_TYPES } from '../../schemas/gameshowConstants.js';

const QUIZ_TYPES = new Set<string>(GAMESHOW_QUIZ_ACTIVITY_TYPES);

export const optionOutcomeEffects: Rule<Gameshow> = {
  code: 'gameshow.option-outcome-effects',
  check(input): ValidationIssue[] {
    const issues: ValidationIssue[] = [];

    input.nodes.forEach((node, idx) => {
      if (!node.activity || !QUIZ_TYPES.has(node.activity.type)) {
        return;
      }
      const setup = (node.activity.setup ?? {}) as Record<string, unknown>;
      const options = setup.options;
      if (!Array.isArray(options)) {
        return;
      }

      options.forEach((opt, oIdx) => {
        const o = asRecord(opt);
        if (!('outcomeEffects' in o) || o.outcomeEffects === undefined) {
          return;
        }

        const value = typeof o.value === 'string' ? o.value : `#${oIdx}`;
        const path: (string | number)[] = ['nodes', idx, 'activity', 'setup', 'options', oIdx, 'outcomeEffects'];
        issues.push({
          code: 'gameshow.option-outcome-effects',
          severity: 'error',
          message: `Node '${node.id}': option '${value}' carries outcomeEffects. Put scoring on the node's top-level outcomeEffects.correct / outcomeEffects.wrong — option-level outcomeEffects are re-applied on the reveal screen by multi_choice_single_response and phrase_matching, doubling scores.`,
          path,
          pointer: toPointer(path),
          locator: { nodeId: node.id },
          constraint: { kind: 'shape', detail: 'option must not carry outcomeEffects' },
        });
      });
    });

    return issues;
  },
};
